/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ConfigChangedPayload
 */
export interface ConfigChangedPayload {
    [key: string]: any | any;
    /**
     * 
     */
    type: ConfigChangedPayloadTypeEnum;
    /**
     * 
     */
    changes: { [key: string]: any; };
}


/**
 * @export
 */
export const ConfigChangedPayloadTypeEnum = {
    ConfigChanged: 'config_changed',
} as const;
export type ConfigChangedPayloadTypeEnum = typeof ConfigChangedPayloadTypeEnum[keyof typeof ConfigChangedPayloadTypeEnum];


/**
 * Check if a given object implements the ConfigChangedPayload interface.
 */
export function instanceOfConfigChangedPayload(value: object): value is ConfigChangedPayload {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (value['type'] !== 'config_changed') return false;
    
    if (!('changes' in value) || value['changes'] === undefined) return false;
    return true;
}

export function ConfigChangedPayloadFromJSON(json: any): ConfigChangedPayload {
    return ConfigChangedPayloadFromJSONTyped(json, false);
}

export function ConfigChangedPayloadFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigChangedPayload {
    if (json == null) {
        return json;
    }
    return {
        
            ...json,
        'type': json['type'],
        'changes': json['changes'],
    };
}

export function ConfigChangedPayloadToJSON(json: any): ConfigChangedPayload {
    return ConfigChangedPayloadToJSONTyped(json, false);
}

export function ConfigChangedPayloadToJSONTyped(value?: ConfigChangedPayload | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
            ...value,
        'type': value['type'],
        'changes': value['changes'],
    };
}

